// TODO: https://jira.moscow.alfaintra.net/browse/SITESMEPRT-1888
/* eslint-disable regex/invalid */
import React, { cloneElement } from 'react';
// eslint-disable-next-line you-dont-need-lodash-underscore/get
import get from 'lodash/get';
// eslint-disable-next-line you-dont-need-lodash-underscore/map
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { getNamedContainers } from '@alfa-bank/site-named-container/utils';
import { NamedContainer } from '@alfa-bank/site-named-container';

import { CurrentPathContext, useCurrentPathContext } from '../../components';

import { arrayChunks, getAppendSlot, withPrepend, replaceDeepLastChildren } from './helpers';
import type { IProps } from './models';
import { usePagination } from './hooks/use-pagination';

/**
 * Итератор
 * */
export const DataIterator = ({
    itemsKey,
    children,
    chunkSize,
    conditions,
    data = {},
    path,
    pagination,
}: IProps) => {
    const { currentPath } = useCurrentPathContext();
    const fullPath = path ? path : itemsKey ? `${currentPath}.${itemsKey}` : currentPath;
    const value = (fullPath ? get(data, fullPath) : data) || [];

    const dataLength = Object.keys(value).length;
    const { append, nextPage, prepend, template, wrapper } = getNamedContainers(children);

    const { NextPageSlot, toSlice } = usePagination({ dataLength, nextPage, pagination });

    if (isEmpty(value)) return null;

    const elements = map(value, (_, index) => {
        // index - индекс массива или ключ перебираемого объекта, если value - объект (например {1: { data }, {2: data }})
        const itemPath = fullPath ? `${fullPath}[${index}]` : String(index);

        return (
            <NamedContainer key={itemPath} name={itemPath}>
                <CurrentPathContext.Provider value={{ currentPath: itemPath }}>
                    {/** Прокидываем в контекст текущий путь до итерируемого элемента, чтобы можно было использовать PropsOverrider */}
                    {template}
                </CurrentPathContext.Provider>
            </NamedContainer>
        );
    })
        // используется для пагинации
        .slice(0, toSlice)
        .concat(
            getAppendSlot({
                // добавляем append слот, если соблюдены условия в conditions?.append
                conditions: conditions?.append,
                append,
                length: dataLength,
            }) as never
        )
        .filter(Boolean);

    if (wrapper) {
        // chunkSize - для отображения элементов в виде сетки, делит массив на чанки.
        // Например массив элементов: [1,2,3,4,5,6,7,8], chunkSize = 3, на выходе получаем: [[1,2,3],[4,5,6],[7,8]]
        if (chunkSize) {
            let i = 0;

            // withPrepend - добавляем prepend слот перед итерируемыми элементами
            return (
                <>
                    {arrayChunks(withPrepend(prepend, elements), chunkSize).map(components => {
                        return cloneElement(wrapper as JSX.Element, {
                            children: replaceDeepLastChildren(
                                components,
                                (wrapper as JSX.Element).props?.children
                            ),
                            key: (i += 1),
                        });
                    })}
                    {NextPageSlot}
                </>
            );
        }

        return (
            <>
                {cloneElement(wrapper as JSX.Element, {
                    // replaceDeepLastChildren - подсовываем elements вместо самого глубокого children во Wrapper слоте
                    children: replaceDeepLastChildren(
                        withPrepend(prepend, elements),
                        (wrapper as JSX.Element).props?.children
                    ),
                })}
                {NextPageSlot}
            </>
        );
    }

    return (
        <>
            {withPrepend(prepend, elements)}
            {NextPageSlot}
        </>
    );
};
